<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert" v-if="alert_success === true">บันทึกข้อมูลเรียบร้อย !</v-alert>
        <v-alert type="error" class="alert" v-if="alert_delete === true">ลบข้อมูลเรียบร้อย !</v-alert>
        <v-alert type="success" class="alert" v-if="alert_status === true">เปลี่ยนสถานะเรียบร้อย !</v-alert>
      </v-slide-x-reverse-transition>
      <v-card elevation="6">
        <div class="pa-2">
          <div class="text-right ma-2">
            <v-btn x-large class="text-center grad-success-bg white--text mobile_btn" @click="logo_modal = true">โลโก้แบรนด์สินค้าใหม่</v-btn>
          </div>
          <div class="pa-2">
            <v-data-table :headers="header" :items="data_list" :footer-props="footer_Props" mobile-breakpoint="0">
              <template v-slot:item="dataDetail">
                <tr>
                  <td class="pa-2">
                    <div class="grid_mx">
                      <v-img class="rounded" height="120" max-width="120" v-if="dataDetail.item.logo_image === ''" :lazy-src="picture_holder" :src="picture_holder"></v-img>
                      <v-img class="rounded" height="120" max-width="120" v-else-if="dataDetail.item.logo_image !== ''" :lazy-src="picture_holder" :src="dataDetail.item.logo_image"></v-img>
                    </div>
                  </td>
                  <td>
                    <div v-if="dataDetail.item.filter_search !== null">{{ dataDetail.item.filter_search }}</div>
                    <div v-else>-</div>
                  </td>
                  <td>
                    <v-switch color="#86bc3a" @change="changeStatus(dataDetail.item.id, dataDetail.item.status)" v-model="dataDetail.item.status"></v-switch>
                  </td>
                  <td>
                    <v-btn small height="42" @click="getEdit(dataDetail.item.id)" class="grad-warning-bg white--text mr-1 mb-1" title="แก้ไขข้อมูล">
                      <v-icon>mdi-note-edit-outline</v-icon>
                    </v-btn>
                    <v-btn small height="42" @click="image_remove(dataDetail.item.id)" class="grad-danger-bg white--text mb-1" title="ลบ">
                      <v-icon>mdi-delete-empty-outline</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>
        </div>
      </v-card>
      <v-dialog v-model="logo_modal" max-width="520">
        <v-card>
          <v-form ref="logo_add" @submit.prevent="save_logo">
            <div class="d-flex justify-space-between">
              <v-card-title>
                เพิ่มโลโก้แบรนด์สินค้า
              </v-card-title>
              <v-btn icon class="ma-4" @click="logo_modal = false">
                <v-icon color="grey">mdi-close</v-icon>
              </v-btn>
            </div>
            <v-card-text>
              <div class="pa-6">
                <div class="ml-2">
                  <v-img height="300" max-width="300" v-if="imagePreviewURL == null" :lazy-src="picture_holder" :src="picture_holder" class="preview mx-auto"></v-img>
                  <v-img height="300" max-width="300" v-if="imagePreviewURL !== null" :lazy-src="picture_holder" :src="imagePreviewURL" class="preview mx-auto"></v-img>
                </div>
                <v-file-input color="#86bc3a" accept="image/*" label="เพิ่มโลโก้แบรนด์สินค้า" v-model="send_data.logo_image" @change="onFileChange"></v-file-input>
                <div class="">
                  <v-text-field color="#86bc3a" label="คำที่นำไปคลิ้กค้นหา" hide-details="auto" v-model="send_data.logo_keyword" :rules="[v => !!v || 'กรุณากรอกคำที่นำไปคลิ้กค้นหา']" required outlined></v-text-field>
                </div>
                <div class="mt-6">
                  <v-btn x-large v-if="imagePreviewURL == null" class="white--text grad-grey-bg btn_size" disabled>อัพโหลด</v-btn>
                  <v-btn x-large v-if="imagePreviewURL !== null" class="white--text grad-success-bg btn_size" type="submit">อัพโหลด</v-btn>
                </div>
              </div>
            </v-card-text>
          </v-form>
        </v-card>
      </v-dialog>
      <v-dialog v-model="logo_edit_modal" max-width="520">
        <v-card>
          <div v-if="loading_edit === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
              <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
          </div>
          <div v-else>
            <v-form ref="logo_edit" @submit.prevent="edit_logo">
              <div class="d-flex justify-space-between">
                <v-card-title>
                  แก้ไขโลโก้แบรนด์สินค้า
                </v-card-title>
                <v-btn icon class="ma-4" @click="logo_edit_modal = false">
                  <v-icon color="grey">mdi-close</v-icon>
                </v-btn>
              </div>
              <v-card-text>
                <div class="pa-6">
                  <div class="ml-2">
                    <v-img height="300" max-width="300" v-if="get_data.logo_image === ''" :lazy-src="picture_holder" :src="picture_holder" class="preview mx-auto"></v-img>
                    <v-img height="300" max-width="300" v-if="get_data.logo_image !== ''" :lazy-src="picture_holder" :src="get_data.logo_image" class="preview mx-auto"></v-img>
                  </div>
                  <v-file-input color="#86bc3a" accept="image/*" label="เพิ่มโลโก้แบรนด์สินค้า" v-model="send_data.logo_edit" @change="onFileChangeEdit"></v-file-input>
                  <div class="">
                    <v-text-field color="#86bc3a" label="คำที่นำไปคลิ้กค้นหา" hide-details="auto" v-model="get_data.filter_search" :rules="[v => !!v || 'กรุณากรอกคำที่นำไปคลิ้กค้นหา']" required outlined></v-text-field>
                  </div>
                  <div class="mt-6">
                    <v-btn x-large v-if="get_data.logo_image === null" class="white--text grad-grey-bg btn_size" disabled>อัพโหลด</v-btn>
                    <v-btn x-large v-if="get_data.logo_image !== null" class="white--text grad-success-bg btn_size" type="submit">อัพโหลด</v-btn>
                  </div>
                </div>
              </v-card-text>
            </v-form>
          </div>
        </v-card>
      </v-dialog>
      <v-overlay :value="overlay" class="z_index">
        <div class="text-center">
          <v-progress-circular
              indeterminate
              size="70"
              width="7"
              color="#86bc3a"
          ></v-progress-circular>
          <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
        </div>
      </v-overlay>
    </div>
  </div>
</template>

<script src="@/previewimage.js"></script>
<script>
import picture_holder from "@/assets/picture.png";
import Swal from "sweetalert2";
import {HTTP} from "@/axios";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Logo_page",
  data() {
    return {
      loading_page: false,
      loading_edit: false,
      logo_modal: false,
      logo_edit_modal: false,
      alert_success: false,
      alert_delete: false,
      alert_status: false,
      picture_holder: picture_holder,
      imagePreviewURL: null,
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      overlay: false,
      send_data: {
        logo_edit: null,
        logo_image: null,
        logo_keyword: '',
      },
      get_data: [],
      header: [
        {
          text: 'โลโก้',
          value: 'logo_image',
          fixed: true,
          width: '250px',
        },
        {
          text: 'คำที่นำไปใช้ค้นหา',
          value: 'filter_search',
          fixed: true,
          width: '250px',
        },
        {
          text: 'สถานะ',
          value: 'status',
          fixed: true,
          width: '200px',
        },
        {
          text: 'จัดการ',
          value: '',
          sortable: false,
          fixed: true,
          width: '300px',
        },
      ],
      data_list: [],
    }
  },
  methods: {
    onFileChange(payload) {
      if (payload !== null && payload !== undefined) {
        const file = payload
        let extall ="png,PNG,jpeg,JPEG,jpg,JPG";
        let file_ext = file.name;
        let ext = file_ext.split('.').pop().toLowerCase();
        if (parseInt(extall.indexOf(ext)) < 0) {
          Swal.fire({
            text: 'อัพโหลดได้เฉพาะไฟล์ รูป หรือ (.png, .PNG, .jpeg, .JPEG, .jpg, .JPG)',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.imagePreviewURL = null
            this.send_data.logo_image = null
          })
        } else {
          if (file) {
            this.imagePreviewURL = URL.createObjectURL(file)
            URL.revokeObjectURL(file)
          } else {
            this.imagePreviewURL = null
            this.send_data.logo_image = null
          }
        }
      }else {
        this.imagePreviewURL = null
        this.send_data.logo_image = null
      }
    },
    onFileChangeEdit(payload) {
      if (payload !== null && payload !== undefined) {
        const file = payload
        let extall ="png,PNG,jpeg,JPEG,jpg,JPG";
        let file_ext = file.name;
        let ext = file_ext.split('.').pop().toLowerCase();
        if (parseInt(extall.indexOf(ext)) < 0) {
          Swal.fire({
            text: 'อัพโหลดได้เฉพาะไฟล์ รูป หรือ (.png, .PNG, .jpeg, .JPEG, .jpg, .JPG)',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.get_data.logo_image = ''
            this.send_data.logo_edit = null
          })
        } else {
          if (file) {
            this.get_data.logo_image = URL.createObjectURL(file)
            URL.revokeObjectURL(file)
          } else {
            this.get_data.logo_image = ''
            this.send_data.logo_edit = null
          }
        }
      }else {
        this.get_data.logo_image = ''
        this.send_data.logo_edit = null
      }
      // const file = payload
      // if (file) {
      //   this.get_data.logo_image = URL.createObjectURL(file)
      //   URL.revokeObjectURL(file)
      // } else {
      //   this.get_data.logo_image = ''
      //   this.send_data.logo_edit = null
      // }
    },
    get_all() {
      this.loading_page = true
      HTTP.post('/manage-website/logos/all')
          .then((res) => {
            if (res.data.success === true) {
              this.loading_page = false
              this.data_list = res.data.object
            }
          })
    },
    save_logo() {
      let extall ="png,PNG,jpeg,JPEG,jpg,JPG";
      let file = this.send_data.logo_image.name;
      let ext = file.split('.').pop().toLowerCase();
      if (parseInt(extall.indexOf(ext)) < 0) {
        Swal.fire({
          text: 'อัพโหลดได้เฉพาะไฟล์ รูป หรือ (.png, .PNG, .jpeg, .JPEG, .jpg, .JPG)',
          icon: 'error',
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        }).then(() => {
          this.imagePreviewURL = null
          this.send_data.logo_image = null
        })
      }
      else {
        if (this.$refs.logo_add.validate()) {
          let config = {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          };
          let formData = new FormData();
          formData.append('logo_image', this.send_data.logo_image, this.send_data.logo_image.name)
          formData.append('filter_search', this.send_data.logo_keyword)
          this.overlay = true
          this.logo_modal = false
          HTTP.post('/manage-website/logos/create', formData, config)
              .then((res) => {
                if (res.data.success === true) {
                  this.overlay = false
                  this.imagePreviewURL = null
                  this.send_data.logo_image = null
                  this.send_data.logo_keyword = ''
                  this.get_all()
                  this.alert_success = true
                  setTimeout(() => this.alert_success = false,3000)
                }
              })
        }
      }
    },
    getEdit(id) {
      this.logo_edit_modal = true
      this.loading_edit = true
      HTTP.post('/manage-website/logos/get', {
        id: id
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_edit = false
          this.get_data = res.data.object
        }
      })
    },
    edit_logo() {
      if (this.$refs.logo_edit.validate()) {
        if (this.send_data.logo_edit !== null && this.send_data.logo_edit !== '') {
          let extall ="png,PNG,jpeg,JPEG,jpg,JPG";
          let file = this.send_data.logo_edit.name;
          let ext = file.split('.').pop().toLowerCase();
          if (parseInt(extall.indexOf(ext)) < 0) {
            Swal.fire({
              text: 'อัพโหลดได้เฉพาะไฟล์ รูป หรือ (.png, .PNG, .jpeg, .JPEG, .jpg, .JPG)',
              icon: 'error',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: `ตกลง`,
              denyButtonText: `ยกเลิก`,
            }).then(() => {
              this.imagePreviewURL = null
              this.send_data.logo_edit = null
            })
          }
          else {
            let config = {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            };
            let formData = new FormData();
            formData.append('id', this.get_data.id)
            formData.append('logo_image', this.send_data.logo_edit, this.send_data.logo_edit.name)
            formData.append('filter_search', this.get_data.filter_search)
            this.overlay = true
            this.logo_edit_modal = false
            HTTP.post('/manage-website/logos/update', formData, config)
                .then((res) => {
                  if (res.data.success === true) {
                    this.overlay = false
                    this.get_all()
                    this.alert_success = true
                    setTimeout(() => this.alert_success = false,3000)
                  }
                })
          }
        }
        else {
          let config = {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          };
          let formData = new FormData();
          formData.append('id', this.get_data.id)
          formData.append('filter_search', this.get_data.filter_search)
          this.overlay = true
          this.logo_edit_modal = false
          HTTP.post('/manage-website/logos/update', formData, config)
              .then((res) => {
                if (res.data.success === true) {
                  this.overlay = false
                  this.get_all()
                  this.alert_success = true
                  setTimeout(() => this.alert_success = false,3000)
                }
              })
        }
      }
    },
    image_remove(id) {
      Swal.fire({
        title: 'คุณต้องการลบโลโก้แบรนด์หรือไม่ ?',
        icon: 'warning',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `ตกลง`,
        denyButtonText: `ยกเลิก`,
      }).then((res) => {
        if (res.isConfirmed === true) {
          HTTP.post('/manage-website/logos/delete', {
            id: id
          }).then((res) => {
            if (res.data.success === true) {
              this.alert_delete = true
              this.get_all()
              setTimeout(() => this.alert_delete = false, 3000)
            }
          })
        }
      })
    },
    changeStatus(id, status) {
      HTTP.post('/manage-website/logos/status', {
        id: id,
        status: status
      }).then((res) => {
        if (res.data.success === true) {
          this.alert_status = true
          setTimeout(() => this.alert_status = false, 3000)
        }
      })
    },
  },
  mounted() {
    this.get_all()
  }
}
</script>

<style scoped>
.alert {
  margin: 0;
  position: fixed !important;
  z-index: 9999;
  top: 15px;
  right: 5px;
}
.btn_size {
  width: 100%;
}
.mobile_btn {
  width: 30%;
}
.grid_mx {
  margin: 0;
}
@media only screen and (max-width: 1180px) {
  .mobile_btn {
    width: 40%;
  }
}
@media only screen and (max-width: 500px) {
  .mobile_btn {
    width: 100%;
  }
  .grid_mx {
    margin: auto;
  }
}
</style>
